// letter-spacing tokens from master-design-system.json → typography.EPIC.letter-spacing
// default=0  tight=-1px  spaced=+1px
export type LetterSpacingToken = "default" | "tight" | "spaced"

export const letterSpacingClasses: Record<LetterSpacingToken, string> = {
  default: "tracking-normal",
  tight:   "tracking-[-0.0625em]",
  spaced:  "tracking-[0.0625em]",
}
